import React from "react"
import styles from "./index.module.scss"

function TableComponent({ thead, children }) {
  const colors = ["", "", "#0066FF", "#B83EE3", "#89C22C"]
  return (
    <div className={styles.containerTable}>
      <table className={styles.table}>
        <thead className={styles.head}>
          <tr>
            {thead.map((item, index) => (
              <th key={index} id={item} className={`th`}>
                <span style={{ color: colors[index] }}>{item}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tableBody}>{children}</tbody>
      </table>
    </div>
  )
}

export const TableRelease = React.memo(TableComponent)
